import { Fragment, Component } from 'react';
import cx from 'classnames';
import { CDN_CLRSAVE_URL, SUBTYPE_MAPPING } from '../../constants';
import styles from '../../styles/homePage/topFunds.scss';
import ReactTooltip from 'react-tooltip';

interface Props {
  fundItem: any;
  width?: any;
  infoWidth?: number;
  valign?: string;
  className?: string;
  subTitleClass?: string;
  imageValign?: string;
  hideSubTitle?: boolean;
  source?: string;
  nfo?: boolean;
  parentClass?: string;
  columnWidth?: number;
}

class FundAvatarNew extends Component<Props> {
  public handleClick = (e: any) => {
    const { fundItem } = this.props;
    const { fundMetaData } = fundItem;
    if (fundMetaData) {
      e.stopPropagation();
    } else {
      e.preventDefault();
    }
  };

  private getFundTitle() {
    const { fundItem, source } = this.props;
    const {
      title,
      fundName,
      fundMetaData,
      nfo,
      planType = 'GROWTH',
    } = fundItem;
    let href = '';
    if (fundMetaData) {
      const { slug, parentSlug, isinCode } = fundMetaData;
      href = nfo
        ? `/mutual-funds/nfo/${parentSlug}/${slug}/${isinCode}?ref=${source}&planType=${planType}`
        : `/mutual-funds/${parentSlug}/${slug}/${isinCode}?ref=${source}&planType=${planType}`;
    }

    return (
      <Fragment>
        <div className={styles.fundTitle}>
          <a
            data-tip={title || fundName}
            data-for="fund-title-new"
            onClick={this.handleClick}
            href={href}
            className="lil-font-semibold sm:lil-text-s-14"
          >
            {title || fundName}
          </a>
        </div>
        <ReactTooltip
          effect="solid"
          id="fund-title-new"
          type="dark"
          backgroundColor="black"
        />
      </Fragment>
    );
  }

  public render() {
    const {
      width,
      infoWidth,
      valign,
      fundItem,
      subTitleClass,
      imageValign,
      hideSubTitle,
      columnWidth,
      className,
    } = this.props;

    const { title, fundName, status, imageUrl } = fundItem;

    return (
      <Fragment>
        <div
          className="lil-flex lil-items-center"
          style={{ width: columnWidth ? columnWidth : 400 }}
        >
          <div className="lil-w-1/6 lil-pr-2">
            <img
              className="lil-rounded-md"
              width="35"
              src={`${CDN_CLRSAVE_URL}/clearsave${imageUrl}`}
              alt={title || fundName}
            />
          </div>
          <div className={`lil-w-5/6 ${className}`}>
            {this.getFundTitle()}
            {!hideSubTitle && (
              <label
                className={cx(
                  'font--grey text--sm block sm:lil-text-s-14',
                  subTitleClass,
                  styles.sub,
                  {
                    [`status--${(status || '').toLowerCase()}`]: status,
                  }
                )}
              >
                {fundItem.subTitle || getFundType(fundItem)}
              </label>
            )}
          </div>
        </div>
        <style jsx>{`
          .image-box {
            width: ${width || 10}%;
            min-width: 20px;
            vertical-align: ${imageValign || 'initial'};
          }

          .info {
            vertical-align: ${valign || 'super'};
            width: ${infoWidth || 75}%;
          }

          @media screen and (max-width: 768px) {
            .info {
              vertical-align: inherit;
            }
          }
        `}</style>
      </Fragment>
    );
  }
}

export default FundAvatarNew;

const getFundType = (fund) => {
  const { mutualFundSubType } = fund;
  if (mutualFundSubType && mutualFundSubType.name) {
    return SUBTYPE_MAPPING[mutualFundSubType.name];
  }

  return fund.fundType;
};



// WEBPACK FOOTER //
// ./components/common/fundAvatarNew.tsx